import React from 'react';
import PropTypes from 'prop-types';
import { ROUTE_LOGIN } from '../../../../constants/Routes';
import Message from '../../../common/message/Message';
import FullPageMessage from '../../../common/fullPageMessage/FullPageMessage';
import {
	ONBOARDING_THIRD_PARTY_COOKIES_TITLE,
	ONBOARDING_THIRD_PARTY_COOKIES_DESCRIPTION,
	ONBOARDING_THIRD_PARTY_COOKIES_CTA,
	ONBOARDING_THIRD_PARTY_COOKIES_HELP,
	ONBOARDING_THIRD_PARTY_COOKIES_CLICK,
} from '../../../../constants/Copy';

const ThirdPartyCookies = (props) => (
	<FullPageMessage
		button={{
			onClick: () => props.history.push(ROUTE_LOGIN),
			testValue: ROUTE_LOGIN,
			text: ONBOARDING_THIRD_PARTY_COOKIES_CTA,
		}}
		title={ONBOARDING_THIRD_PARTY_COOKIES_TITLE}
		description={
			<Message
				message={ONBOARDING_THIRD_PARTY_COOKIES_DESCRIPTION}
				values={{
					link: (
						<a
							className="onboarding__link"
							target="_blank"
							data-test="full-page-message-help-link"
							href={ONBOARDING_THIRD_PARTY_COOKIES_HELP}
							rel="noopener"
						>
							{ONBOARDING_THIRD_PARTY_COOKIES_CLICK}
						</a>
					),
				}}
			/>
		}
	/>
);

ThirdPartyCookies.propTypes = {
	history: PropTypes.object.isRequired,
};

export default ThirdPartyCookies;
